import React from "react";
import { useTranslation } from "react-multi-lang";
import MaskText from "../Utility/MaskText";
import CopyBtn from "../Utility/CopyBtn";
import { display } from "../Utility/Utility";

const SettlementMode = ({ settlement }) => {
  const t = useTranslation("settlement.settlement_modal");

  const {
    type_formatted,
    bank_account,
    crypto
  } = settlement || {};

  const type = (type_formatted || "").toUpperCase();

  const {
    bank_name,
    account_holder_name,
    ifsc_code,
    account_number,
  } = bank_account || {};

  const {
    wallet_address,
    transaction_hash
  } = crypto || {};

  return (
    <><div className="view-modal-card-wrap">
      {/* Type */}
      <div className="view-modal-card">
        <div>{t("mode")}</div>
        <div>{display(type)}</div>
      </div>

      {/* BANK */}
      {type === "BANK" && (
        <>
          <div className="view-modal-card">
            <div>{t("bank_name")}</div>
            <div>{display(bank_name)}</div>
          </div>

          <div className="view-modal-card">
            <div>{t("account_holder_name")}</div>
            <div>{display(account_holder_name)}</div>
          </div>

          <div className="view-modal-card">
            <div>{t("ifsc_code")}</div>
            <div>
              {display(ifsc_code)}
              <CopyBtn
                text={ifsc_code}
                notification={t("copied")}>
              </CopyBtn>
            </div>
          </div>

          <div className="view-modal-card">
            <div>{t("account_number")}</div>
            <div>
              {display(account_number)}
              <CopyBtn
                text={account_number}
                notification={t("copied")}>
              </CopyBtn>
            </div>
          </div>
        </>
      )}

      {/* CRYPTO */}
      {type === "CRYPTO" && (
        <>
          <div className="view-modal-card">
            <div>{t("wallet_address")}</div>
            <div>
              <MaskText
                text={wallet_address}
                count={20}
                maskChar="."
              />
              <CopyBtn
                text={wallet_address}
                notification={t("copied")}>
              </CopyBtn>
            </div>
          </div>

          <div className="view-modal-card">
            <div>{t("transaction_hash")}</div>
            <div>
              <MaskText
                text={transaction_hash}
                count={25}
                maskChar="."
              />
              <CopyBtn
                text={transaction_hash}
                notification={t("copied")}>
              </CopyBtn>
            </div>
          </div>
        </>
      )}
    </div>
    </>
  );
};

export default SettlementMode;